<div class="container-fluid d-flex flex-row justify-content-center mb-0 mt-md-1 pt-0 pb-3 pb-lg-5 pb-xl-3 shadow-lg col-12 col-lg-10">
    <div class="jumbotron-fluid mx-0 px-0 mb-0 mb-lg-5 mb-xl-1 pb-1 pb-lg-5 pb-xl-2 col-12 col-md-11">
        <div class="container mt-1 mt-md-3 mt-xl-1 mx-0 shadow-lg col-12">
            <div class="row">
                <div class="col-12">
                    <h3 class="rub-head4 text-info text-center font-weight-bold py-1">
                        Business Unit Setup
                    </h3>
                </div>
            </div>
        </div>
    <div class="invest-card card-body mt-2 pt-4 mb-3 mx-auto pb-3 shadow-lg">
      <form [formGroup]="unitForm">
        <div class="row">
          <div class="col-12">
            <div class="form-group text-secondary">
              <div class="input-group mb-0">
                <input
                  id="bussinessUnitName"
                  formControlName="bussinessUnitName"
                  type="text"
                  class="form-control col-sm-7 col-md-6 col-lg-5"
                  placeholder="Enter name to create unit"
                  autocomplete="off"
                  [ngClass]="{
                    'is-invalid':
                      (fval.bussinessUnitName.touched
                      || fval.bussinessUnitName.dirty) &&
                      fval.bussinessUnitName.errors
                  }"
                />
                &nbsp;
                <button type="button" class="btn btn-info mx-auto mx-sm-0 px-lg-4"
                (click)= "createUnit()"
                >
                  Create
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="item-header">
          <div class="row" >
            <div class="col-7">
              <h4 class="text-center text-info">Unit</h4>
            </div>
            <div class="col-5 justify-content-center">
              <h4 class="text-center text-info">Action</h4>
            </div>
          </div>
        </div>
        <div class="iteration mt-1 mb-3 py-0"
        formArrayName= "bussinessUnits"
        >
        <div class="item-container my-1 py-0"
        *ngFor="let units of fval.bussinessUnits['controls'];let i = index"
            >
          <div
            class="list-card card my-0 py-1 mx-0 px-0 shadow-lg" [formGroupName]="i"
          >
            <div class="list-card-body card-body my-0 py-0 mx-0 px-3" >
              <div class="row my-0 py-0" >
                <div class="col-7">
                  <div class="form-group text-primary">
                    <input
                      type="text"
                      formControlName = 'unitName'
                      class="form-control level-control"
                      autocomplete="off"
                      [ngClass]="{
                        'is-invalid':
                          (fval.bussinessUnits['controls'][i]['controls']['unitName'].touched
                          || fval.bussinessUnits['controls'][i]['controls']['unitName'].dirty) &&
                          fval.bussinessUnits['controls'][i]['controls']['unitName'].errors
                      }"
                    />
                  </div>
                </div>
                <div class="col-5 d-flex justify-content-center">
                  <button
                    class="edit-button btn-sm btn-infob col-3 ml-0 ml-sm-3 pt-0 pb-3 px-2"
                    (click)= "editUnit(i)"
                  >
                    <i class="fas fa-edit" tooltip="Edit" placement="right"></i>
                  </button>
                  &nbsp;
                  <button
                    class="save-button btn-sm btn-infob col-3 mr-3 pt-1 pb-3 px-2"
                    [disabled] = "fval.bussinessUnits['controls'][i].pristine || fval.bussinessUnits['controls'][i].invalid"
                    (click)="saveUnit(i)"
                  >
                    <i class="fas fa-save" tooltip="Save" placement="right"></i>
                  </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
    </div>
    </div>
